import { ClientHandler } from '../../../types';
import { getClippingHelpers } from '../../../constants/clients/GVAZ/helpers';

export const GVAZHandler: ClientHandler = {
  getBannerMetadata: banner => {
    if (!banner || !banner.bannerType) {
      return null; // Retornar null para que use el fallback
    }
    return getClippingHelpers().getBannerMetadata(banner);
  }
};
